// What is typed into the New Shipment form.
import { jordanDate } from '@serb/shared';
import { SAMPLE_DATA } from '../../../lib/sample';

export type ShipmentForm = {
  srb: string;
  customer: string;
  contact: string;
  email: string;
  shipmentType: string;
  mode: string;
  created: string;
  operator: string;
  origin: string;
  destination: string;
  incoterm: string;
  commodity: string;
  packages: string;
  packageUnit: string;
  grossWeight: string;
  volume: string;
  length: string;
  width: string;
  height: string;
  stackable: 'Stackable' | 'Non-stackable';
  dangerous: 'Yes' | 'No';
  cargoDescription: string;
  readyDate: string;
  serviceRequirements: string;
  specialInstructions: string;
  notes: string;
  files: string[];
};

export const SHIPMENT_TYPES = ['FCL', 'LCL', 'Air', 'Road'];
export const MODES = ['Sea Freight', 'Air Freight', 'Road Freight'];
export const PACKAGE_UNITS = ['Pallets', 'Cartons', 'Packages', 'Containers'];

/** The next free SRB code: one more than the highest we know */

const BLANK: ShipmentForm = {
  srb: '',
  customer: '',
  contact: '',
  email: '',
  shipmentType: '',
  mode: '',
  created: '',
  operator: 'Ibraheem',
  origin: '',
  destination: '',
  incoterm: '',
  commodity: '',
  packages: '',
  packageUnit: 'Pallets',
  grossWeight: '',
  volume: '',
  length: '',
  width: '',
  height: '',
  stackable: 'Stackable',
  dangerous: 'No',
  cargoDescription: '',
  readyDate: '',
  serviceRequirements: '',
  specialInstructions: '',
  notes: '',
  files: [],
};

/** A new form. While sample data is on, it starts filled in so the design can be judged. */
export function initialShipmentForm(): ShipmentForm {
  const base = { ...BLANK, srb: '', created: jordanDate() };
  if (!SAMPLE_DATA) return base;
  return {
    ...base,
    customer: 'ABC Trading',
    contact: 'Mr. Ahmad Khalil',
    email: 'ahmad@abctrading.com',
    shipmentType: 'FCL',
    mode: 'Sea Freight',
    origin: 'Guangzhou (CAN)',
    destination: 'Aqaba (AQJ)',
    incoterm: 'EXW',
    commodity: 'Machinery parts',
    packages: '14',
    grossWeight: '4774',
    volume: '16.48',
    length: '120',
    width: '100',
    height: '110',
    cargoDescription: 'Machinery parts, general cargo, non-hazardous.',
    readyDate: jordanDate(),
  };
}

/** The steps after saving. The first one is where you are. */
export const NEXT_STEPS = [
  'Save shipment',
  'Request supplier rates',
  'Create quotation',
  'Upload documents',
  'Update status',
];
